﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = require("classnames");
const form_controls_1 = require("@its-suite/form-controls");
const app_commons_1 = require("@its-suite/app-commons");
const Utils_1 = require("../../Utils");
const AccountCircle_1 = require("@material-ui/icons/AccountCircle");
const Menu_1 = require("@material-ui/icons/Menu");
const ArrowDropDown_1 = require("@material-ui/icons/ArrowDropDown");
const containers_1 = require("../../containers");
const styles = require("./AppBar.scss");
const prefixId = Utils_1.PrefixId.AppBar;
var HtmlElementsIdentifiers;
(function (HtmlElementsIdentifiers) {
    HtmlElementsIdentifiers["AppMenu"] = "AppMenu";
    HtmlElementsIdentifiers["AppArea"] = "AppArea";
    HtmlElementsIdentifiers["UserMenu"] = "UserMenu";
    HtmlElementsIdentifiers["UserArea"] = "UserArea";
    HtmlElementsIdentifiers["AppInfoArea"] = "AppInfoArea";
    HtmlElementsIdentifiers["SideMenu"] = "SideMenu";
})(HtmlElementsIdentifiers || (HtmlElementsIdentifiers = {}));
class AppBarInternal extends React.Component {
    constructor(props) {
        super(props);
        this.appIconSize = form_controls_1.StringHelpers.getNumber(styles.appIconSize);
        this.onToggleSideMenu = () => {
            this.setState({ sideMenuOpen: !this.state.sideMenuOpen });
        };
        this.onToggleAppMenu = () => {
            this.setState({ appMenuOpen: !this.state.appMenuOpen });
        };
        this.onBlurAppMenu = () => {
            if (this.state.appMenuOpen) {
                this.setState({ appMenuOpen: false });
            }
        };
        this.onToggleUserMenu = () => {
            this.setState({ userMenuOpen: !this.state.userMenuOpen });
        };
        this.onBlurUserMenu = () => {
            if (this.state.userMenuOpen) {
                this.setState({ userMenuOpen: false });
            }
        };
        this.getAppIcon = (app) => {
            return (React.createElement(form_controls_1.IconTint, { className: styles.appListItemImg, style: { background: app.color }, height: this.appIconSize, width: this.appIconSize, src: form_controls_1.StringHelpers.getBase64ImgSrc(form_controls_1.FileTypes.ImageExtension.svg, app.icon), color: styles.textColor }));
        };
        this.renderCustomContentCenter = () => {
            return (React.createElement("div", null, this.props.customContentCenter));
        };
        this.renderCustomContentRight = () => {
            let className = '';
            if (this.props.session) {
                className = `${className} ${styles.verticalSeparatorRight}`;
            }
            return (React.createElement("div", { className: className }, this.props.customContentRight));
        };
        this.renderMenuButton = () => {
            if (this.props.menuOptions) {
                return (React.createElement("div", { className: styles.appMenuContainer },
                    React.createElement(form_controls_1.IconButton, { onClick: this.onToggleSideMenu },
                        React.createElement(Menu_1.default, { fontSize: 'large' }))));
            }
            return null;
        };
        this.getCurrentApp = () => {
            let currentApp;
            if (this.props.applications) {
                currentApp = this.props.applications.find(app => app.name === this.props.appName);
            }
            return currentApp;
        };
        this.renderAppMenu = () => {
            let currentApp = this.getCurrentApp();
            if (!this.props.applications || !currentApp) {
                return null;
            }
            else {
                let appSelectorInteractive = this.props.applications.length > 1;
                let arrowIcon = null;
                let selectedAppMenuOption = null;
                if (appSelectorInteractive) {
                    arrowIcon = React.createElement(ArrowDropDown_1.default, { fontSize: 'small', className: `${styles.icon}` });
                }
                if (currentApp) {
                    selectedAppMenuOption = (React.createElement(form_controls_1.IconButton, { disabled: !appSelectorInteractive, className: styles.appMenuButton, onClick: this.onToggleAppMenu },
                        this.getAppIcon(currentApp),
                        arrowIcon));
                }
                return (React.createElement(form_controls_1.ClickAwayListener, { onClickAway: this.onBlurAppMenu },
                    React.createElement("div", { id: HtmlElementsIdentifiers.AppArea, className: styles.appMenuContainer },
                        selectedAppMenuOption,
                        this.state.appMenuOpen && this.renderAppMenuOpen(currentApp))));
            }
        };
        this.renderAppMenuOpen = (currentApp) => {
            let menuOptions = [];
            this.props.applications.filter(app => app !== currentApp).forEach(app => {
                let menuOption = {
                    id: app.url,
                    icon: this.getAppIcon(app),
                    actionProps: this.getAppMenuAction(app, currentApp),
                    primaryText: this.props.translate(app.textKey, app.textResourceFileName)
                };
                menuOptions.push(menuOption);
            });
            return (React.createElement("div", { id: HtmlElementsIdentifiers.AppMenu, className: styles.verticalMenu },
                React.createElement("ul", { key: HtmlElementsIdentifiers.AppMenu },
                    React.createElement(form_controls_1.NestedList, { menuOptions: menuOptions, prefixId: prefixId, iconClassName: styles.appListIcon }))));
        };
        this.getAppMenuAction = (app, currentApp) => {
            return {
                link: app_commons_1.UrlHelper.getFullAppUrl(app.url, this.props.appConfig),
                internalLink: currentApp.embeddedBundle || app.url.startsWith('http') ? app.embeddedBundle : false,
                openInNewPage: app.openInNewPage
            };
        };
        this.renderProductInfo = () => {
            let className = styles.appMenuContainer;
            if (this.getCurrentApp()) {
                className = `${className} ${styles.verticalSeparatorLeft}`;
            }
            return (React.createElement("div", { className: className },
                React.createElement(app_commons_1.ProductInfo, { productVersion: this.props.appVersion })));
        };
        this.renderUserMenu = () => {
            return (React.createElement(form_controls_1.ClickAwayListener, { onClickAway: this.onBlurUserMenu },
                React.createElement("div", { className: styles.userInfoContainer },
                    React.createElement("div", { id: HtmlElementsIdentifiers.UserArea },
                        React.createElement("span", { className: styles.userName }, this.props.session.username),
                        React.createElement(form_controls_1.IconButton, { onClick: this.onToggleUserMenu },
                            React.createElement(AccountCircle_1.default, { fontSize: 'large' })),
                        this.state.userMenuOpen && this.renderUserMenuOpen()))));
        };
        this.renderUserMenuOpen = () => {
            let userActions = [];
            if (this.props.userActions) {
                userActions.push(...this.props.userActions);
            }
            userActions.push({
                text: this.props.translate('UserProfile'),
                action: {
                    onClick: () => { this.setState({ showProfileForm: true }); }
                },
                id: form_controls_1.IdentifierHelpers.createId('userprofile', form_controls_1.IdentifierHelpers.IdForElement.Button)
            });
            const logoutRoute = app_commons_1.ApplicationRoutes.LOGOUT;
            userActions.push({ text: this.props.translate('Logout'), action: { link: logoutRoute, internalLink: true, openInNewPage: false }, id: logoutRoute });
            let userMenuOptions = [];
            userActions.forEach(userAction => {
                let linkAction = form_controls_1.NestedList.getLinkActionProps(userAction.action);
                let handlerAction = form_controls_1.NestedList.getHandlerActionProps(userAction.action);
                let actionProps;
                if (linkAction) {
                    actionProps = linkAction;
                }
                else if (handlerAction) {
                    actionProps = {
                        onClick: () => {
                            handlerAction.onClick();
                            this.onBlurUserMenu();
                        }
                    };
                }
                let menuOption = {
                    actionProps: actionProps,
                    primaryText: userAction.text,
                    id: userAction.id
                };
                userMenuOptions.push(menuOption);
            });
            return (React.createElement("div", { id: HtmlElementsIdentifiers.UserMenu, className: styles.userMenu },
                React.createElement("ul", null, React.createElement(form_controls_1.NestedList, { menuOptions: userMenuOptions, prefixId: prefixId, key: HtmlElementsIdentifiers.UserMenu }))));
        };
        this.renderLeftMenuOptions = () => {
            var _a;
            let className = this.props.enabled ? '' : styles.disable;
            if (((_a = this.props.menuOptions) === null || _a === void 0 ? void 0 : _a.length) > 0 && this.state.sideMenuOpen) {
                return (React.createElement("div", { id: HtmlElementsIdentifiers.SideMenu, className: classnames_1.default(styles.sideMenu, className) },
                    React.createElement("nav", null,
                        React.createElement("ul", null,
                            React.createElement(form_controls_1.NestedList, { menuOptions: this.props.menuOptions, key: HtmlElementsIdentifiers.SideMenu, currentRoute: this.props.location.pathname, prefixId: prefixId })))));
            }
            return null;
        };
        this.render = () => {
            console.log('AppBar render');
            let centeredContentClassName = styles.centeredContent;
            if (!this.state.sideMenuOpen) {
                centeredContentClassName = `${styles.centeredContent} ${styles.centeredContentHiddenMenu}`;
            }
            return (React.createElement("div", null,
                React.createElement("nav", { className: styles.appBar, style: { width: this.props.containerWidth ? this.props.containerWidth : '100%' } },
                    React.createElement("div", { className: styles.appMenuContainer },
                        this.renderMenuButton(),
                        this.renderAppMenu(),
                        this.renderProductInfo()),
                    this.props.customContentCenter && this.renderCustomContentCenter(),
                    React.createElement("div", { className: styles.appMenuContainer },
                        this.props.customContentRight && this.renderCustomContentRight(),
                        this.props.session && this.renderUserMenu())),
                React.createElement("div", { className: styles.appContent },
                    this.renderLeftMenuOptions(),
                    this.state.showProfileForm && this.renderProfileForm(),
                    React.createElement("div", { className: centeredContentClassName }, this.props.appContent))));
        };
        this.renderProfileForm = () => {
            return (React.createElement(form_controls_1.ModalWindow, { open: this.state.showProfileForm, title: this.getFormTitle(), prefixId: prefixId, onClose: this.onCloseForm },
                React.createElement(containers_1.UserProfileForm, { onClose: this.onCloseForm })));
        };
        this.onCloseForm = () => {
            this.setState({ showProfileForm: false });
        };
        this.state = {
            appMenuOpen: false,
            userMenuOpen: false,
            sideMenuOpen: this.props.sidebarOpen ? this.props.sidebarOpen : false,
            showProfileForm: false
        };
    }
    getFormTitle() {
        return this.props.translate('UserProfile');
    }
}
AppBarInternal.defaultProps = { enabled: true };
function mapStateToProps(state) {
    return {
        appConfig: state.appStaticConfig,
        applications: state.applications,
        session: state.session,
        translate: state.translate
    };
}
exports.AppBar = react_router_dom_1.withRouter(react_redux_1.connect(mapStateToProps)(AppBarInternal));
//# sourceMappingURL=AppBar.js.map